import React from 'react';
import { PanelResizeHandle } from 'react-resizable-panels';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const Wrapper = styled('div')(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&:hover .resize-line-horizontal, &:hover .resize-line-vertical': {
        backgroundColor: theme.palette.text.primary,
    },
    '&:hover .resize-dot': {
        opacity: 1,
        backgroundColor: theme.palette.text.primary,
    },
}));

const Base = styled(PanelResizeHandle)({
    position: 'relative',
    backgroundColor: 'transparent',
    width: '100%',
    height: '100%',
});

const Horizontal = styled('div')({
    width: 12,
    cursor: 'col-resize',
    height: '100%',
});

const Vertical = styled('div')({
    height: 12,
    cursor: 'row-resize',
    width: '100%',
});

const LineHorizontal = styled('div')({
    position: 'absolute',
    top: 3,
    bottom: 3,
    left: '50%',
    width: 2,
    backgroundColor: '#bbb',
    transform: 'translateX(-50%)',
    transition: 'background-color 0.2s ease',
});

const LineVertical = styled('div')({
    position: 'absolute',
    left: 3,
    right: 3,
    top: '50%',
    height: 2,
    backgroundColor: '#bbb',
    transform: 'translateY(-50%)',
    transition: 'background-color 0.2s ease',
});

const Dot = styled('div')({
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: 6,
    height: 6,
    backgroundColor: '#bbb',
    borderRadius: '50%',
    transform: 'translate(-50%, -50%)',
    opacity: 0,
    transition: 'opacity 0.2s ease, background-color 0.2s ease',
});

export const StyledGridContainerBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    overflow: 'hidden',
});

const CustomResizeHandle = ({
    direction = 'horizontal',
}: {
    direction?: 'horizontal' | 'vertical';
}) => {
    const isHorizontal = direction === 'horizontal';

    return (
        <Wrapper
            className={isHorizontal ? 'horizontal-wrapper' : 'vertical-wrapper'}
        >
            <Base
                className={isHorizontal ? 'horizontal-base' : 'vertical-base'}
                hitAreaMargins={{ coarse: 2, fine: 2 }}
            >
                {isHorizontal ? (
                    <>
                        <Horizontal>
                            <LineHorizontal className="resize-line-horizontal" />
                        </Horizontal>
                    </>
                ) : (
                    <>
                        <Vertical>
                            <LineVertical className="resize-line-vertical" />
                        </Vertical>
                    </>
                )}
                <Dot className="resize-dot" />
            </Base>
        </Wrapper>
    );
};

export default CustomResizeHandle;
